const TextCardSkeleton = () => {
  return (
    <div className="relative flex flex-col px-4 pb-6 bg-base-100 shadow rounded-box">
      <div className="absolute top-5 right-6 w-15 h-15 skeleton" />
      <div className="mt-7 w-36 h-9 skeleton mb-2" />
      <div className="w-48 h-4 skeleton mb-2" />
    </div>
  );
};

export default TextCardSkeleton;
